/**
 * Azzari - Badge de economia
 */
(function () {
  function formatMoney(cents) {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(cents / 100);
  }

  function injectBadge(priceContainer) {
    if (!priceContainer) return;
    const existing = priceContainer.querySelector('.azzari-savings-badge');
    if (existing) existing.remove();
    const saleItem = priceContainer.querySelector('.price-item--sale');
    const compareItem = priceContainer.querySelector('.price-item--compare s, .price-item--compare');
    if (!saleItem || !compareItem) return;
    const variant = window.__azzari_selected_variant;
    if (!variant) return;
    const price = variant.price;
    const comparePrice = variant.compare_at_price;
    if (!comparePrice || comparePrice <= price) return;
    const savings = comparePrice - price;
    const badge = document.createElement('span');
    badge.className = 'azzari-savings-badge';
    badge.textContent = 'Ahorra ' + formatMoney(savings);
    priceContainer.querySelector('.price__container').appendChild(badge);
  }

  function setupVariantTracking() {
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function () {
        setTimeout(function () {
          document.querySelectorAll('.price').forEach(injectBadge);
        }, 300);
      });
    }
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('price')) injectBadge(node);
          const priceNodes = node.querySelectorAll && node.querySelectorAll('.price');
          if (priceNodes && priceNodes.length) priceNodes.forEach(injectBadge);
        });
      });
    });
    const productInfo = document.querySelector('.product__info-container, [id*="MainProduct"]');
    if (productInfo) observer.observe(productInfo, { childList: true, subtree: true });
  }

  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(function (response) {
      const url = response.url || '';
      if (url.includes('.js') && url.includes('variants')) {
        response.clone().json().then(function (data) {
          if (data && data.price !== undefined) {
            window.__azzari_selected_variant = data;
            setTimeout(function () {
              document.querySelectorAll('.price').forEach(injectBadge);
            }, 200);
          }
        }).catch(function () {});
      }
      return response;
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    setupVariantTracking();
    const variantDataEl = document.querySelector('[data-selected-variant]') ||
                          document.getElementById('ProductJson-product-template');
    if (variantDataEl) {
      try {
        const data = JSON.parse(variantDataEl.textContent || variantDataEl.dataset.selectedVariant);
        if (data) {
          window.__azzari_selected_variant = data.variants ? data.variants[0] : data;
          document.querySelectorAll('.price').forEach(injectBadge);
        }
      } catch (e) {}
    }
  });
})();
